<div class="mega_body-content">
  <div
    class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information"
    [ngClass]="{ 'edit_mega_header-information': isEditMegaFlow }"
  >
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="mega_header-information__sub-header">{{ headerSubText }}</div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="warningMessage.show">
    <div class="message-container message-container--warning">
      <span class="status-icon">
        <ng-container>
          <i class="fa fa-exclamation-circle status-icon--md"></i>
        </ng-container>
      </span>
      <div class="status-message">
        <div class="status-content">{{ warningMessage.message }}</div>
      </div>
    </div>
  </ng-container>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
    <div class="line-break"></div>
  </div>

  <ng-container *ngIf="!isEditMegaFlow">
    <div class="col-12 col-sm-12 col-md-5 col-lg-5 mega-trade-form-info">
      <p>
        Complete the form to get started. When you are done, you will be given a chance to review
        and make any changes. Upon confirmation, you will receive your Pool Number and CUSIP.<br /><br />Please
        note, Megas and Supers cannot settle on weekends or holidays and must settle at least
        <b>two business</b> days in the future. If you would like to settle sooner, please contact
        Structured Transactions to discuss your options.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isEditMegaFlow">
    <div class="col-12 col-sm-12 col-md-5 col-lg-5 mega-trade-form-info">
      <p>
        Edit your pool using the form. Please note if you would like to change the Pool Type, you
        will need to create a new pool. <br /><br />Megas and Supers cannot settle on weekends or
        holidays and must settle at least <b>two business days</b> in the future. If you would like
        to settle sooner, please contact Structured Transactions to discuss your options.
      </p>
    </div>
  </ng-container>

  <div class="col-12 col-sm-12 col-md-7 col-lg-7 mega-trade-form">
    <div class="row mega-selection-block">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 mega-type">
        <label>Pool Type</label>

        <!--<div class="fm-cdx-select p__bottom-32">-->
        <!--<select name="typeSelection"-->
        <!--[disabled]="isDisableMegaTypeSelection"-->
        <!--[ngModel]="selectedMegas ? selectedMegas : selectMegaTypePlaceholder"-->
        <!--(ngModelChange)="setSelectedMegaType($event)">-->
        <!--<option disabled [ngValue]="selectMegaTypePlaceholder">Select Mega Type</option>-->
        <!--<option *ngFor="let mMegaType of megaPrefixs" [ngValue]="mMegaType">-->
        <!--{{ mMegaType?.displayMegaType }}-->
        <!--</option>-->
        <!--</select>-->
        <!--</div>-->

        <div class="fm-cdx-select p__bottom-32">
          <select
            name="typeSelection"
            [disabled]="isDisableMegaTypeSelection"
            [ngModel]="selectedMegas"
            (ngModelChange)="setSelectedMegaType($event)"
          >
            <option disabled [ngValue]="undefined">Select Mega Type</option>
            <option
              *ngFor="let mMegaType of megaPrefixs; trackBy: trackByIdentity"
              [ngValue]="mMegaType"
            >
              {{ mMegaType?.displayMegaType }}
            </option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="selectedMegas != null && isSingleFamilyFixSelected">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <form class="row mega-type-form" [formGroup]="requestSingleFamilyFixMegaForm">
            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Prefix</label>

                <div class="fm-cdx-select p__bottom-32">
                  <select
                    name="singleFamilyFixPrefixSelection"
                    formControlName="singleFamilyFixPrefixSelControl"
                    [ngModel]="selectedSingleFamilyFixPrefix"
                    (ngModelChange)="setSingleFamilyFixSelectedPrefix($event)"
                  >
                    <option disabled [ngValue]="null">Select a prefix</option>
                    <option
                      *ngFor="let prefix of selectedMegas?.prefixTypes; trackBy: trackByIdentity"
                      [ngValue]="prefix"
                    >
                      {{ prefix.prefixCode }}
                    </option>
                  </select>
                </div>

                <!--<div class="dropdown p__bottom-32">-->
                <!--<button  class="btn btn-secondary dropdown-toggle mega-type-dropdown"-->
                <!--type="button"-->
                <!--id="dropdownSelectSingleFamilyFixedPrefix"-->
                <!--data-bs-toggle="dropdown"-->
                <!--aria-haspopup="true"-->
                <!--aria-expanded="true">-->
                <!--{{selectedSingleFamilyFixPrefix ? selectedSingleFamilyFixPrefix.prefixCode : selectPrefixPlaceholder}}-->
                <!--<span class="fa fa-chevron-down mega-dropdown-caret"></span>-->
                <!--</button>-->
                <!--<ul class="dropdown-menu"-->
                <!--aria-labelledby="dropdownSelectSingleFamilyFixedPrefix">-->
                <!--<li *ngFor="let prefix of selectedMegas?.prefixTypes">-->
                <!--<a (click)="setSingleFamilyFixSelectedPrefix(prefix)" class="dropdown-item">-->
                <!--{{ prefix?.prefixCode }}-->
                <!--</a>-->
                <!--</li>-->
                <!--</ul>-->
                <!--</div>-->
              </div>

              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Coupon</label>
                <input
                  class="enter-coupon-amount--input linear__user__flow p__bottom-32"
                  type="text"
                  id="singleFamilyFixInputCoupon"
                  onCopy="return false;"
                  onCut="return false;"
                  onpaste="return false;"
                  ondrag="return false;"
                  onDrop="return false;"
                  formControlName="singleFamilyFixCouponInputControl"
                  invdUptoThreeDecimal
                  placeholder="Enter coupon"
                  [(ngModel)]="sfFixCouponInput"
                  autocomplete="off"
                  (keydown.enter)="
                    formatCouponDecimal(
                      $event,
                      requestSingleFamilyFixMegaForm.controls.singleFamilyFixCouponInputControl
                    )
                  "
                  (blur)="
                    formatCouponDecimal(
                      $event,
                      requestSingleFamilyFixMegaForm.controls.singleFamilyFixCouponInputControl
                    )
                  "
                />
              </div>
            </div>

            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-deal-amount">
                <label>Deal Amount</label>
                <div class="input-group-container">
                  <ng-container
                    *ngIf="
                      requestSingleFamilyFixMegaForm.controls.singleFamilyFixMegaAmountInputControl
                        .value !== '' &&
                      isDealAmtLessThanOneThousand &&
                      !requestSingleFamilyFixMegaForm.controls.singleFamilyFixMegaAmountInputControl
                        .pristine
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error enter-mega-trade-error-tooltip"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The deal amount for a mega must be more than $1,000. Please try again."
                    ></i>
                  </ng-container>
                  <span class="currency-addon">$</span>
                  <input
                    class="enter-coupon-amount--input linear__user__flow p__bottom-32"
                    [textMask]="{ mask: numberMask }"
                    id="singleFamilyFixInputMegaAmount"
                    onCopy="return false;"
                    onCut="return false;"
                    onpaste="return false;"
                    ondrag="return false;"
                    onDrop="return false;"
                    formControlName="singleFamilyFixMegaAmountInputControl"
                    type="text"
                    invdWholeNumberOnly
                    placeholder="Enter deal amount"
                    [(ngModel)]="sfFixDealAmount"
                    (blur)="
                      validateDealAmount(
                        requestSingleFamilyFixMegaForm.controls
                          .singleFamilyFixMegaAmountInputControl
                      )
                    "
                    (focus)="isDealAmtLessThanOneThousand = false"
                    autocomplete="off"
                  />
                </div>
              </div>

              <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-settelment-date">
                <label>Settlement Date</label>
                <div class="input-group-container p__bottom-32">
                  <i
                    class="fa fa-calendar calendar-addon"
                    id="sffmCalenderBtn"
                    (click)="dp.openCalendar()"
                  ></i>

                  <span id="sffmCalenderCtr">
                    <input
                      class="input-calendar"
                      readonly
                      (dateChanged)="onDateChanged($event)"
                      (click)="dp.openCalendar()"
                      placeholder="mm/dd/yyyy"
                      [(ngModel)]="calendarModel"
                      angular-mydatepicker
                      formControlName="singleFamilyFixMegaSettlemntDateControl"
                      [options]="singleFamilyFixMegaSettlemntDateControlOptions"
                      #dp="angular-mydatepicker"
                    />
                  </span>

                  <div class="calender-busy-indicator" *ngIf="showCalendarBusyIndicator">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw spinner-pos" aria-hidden="true"></i>
                    <span class="loading-calender-text">loading calendar...</span>
                  </div>

                  <span
                    class="calender-tool-tip fa-stack fa-lg tooltip-error enter-mega-trade-error-tooltip"
                    aria-hidden="true"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    *ngIf="canIShowCalenderToolTip(dateSelected)"
                    title="The market closes early on the day you chose. Please be sure staff is available to complete this transaction."
                  >
                    <i class="fa fa-info fa-stack-1x"></i>
                    <i class="fa fa-circle-thin fa-stack-2x"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedMegas != null && isSingleFamilyARMSelected">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <form class="row mega-type-form" [formGroup]="requestSingleFamilyArmMegaForm">
            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Prefix</label>
                <div class="fm-cdx-select p__bottom-32">
                  <select
                    name="singleFamilyArmPrefixSelection"
                    formControlName="singleFamilyArmPrefixSelControl"
                    [ngModel]="singleFamilyArmSelectedPrefix"
                    (ngModelChange)="singleFamilyArmSetSelectedPrefix($event)"
                  >
                    <option disabled [ngValue]="null">Select a prefix</option>
                    <option
                      *ngFor="let prefix of selectedMegas?.prefixTypes; trackBy: trackByIdentity"
                      [ngValue]="prefix"
                    >
                      {{ prefix.prefixCode }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Subtype</label>
                <ng-container
                  *ngIf="
                    requestSingleFamilyArmMegaForm.controls.singleFamilyArmSubTypeInputControl.hasError(
                      'subTypeError'
                    )
                  "
                >
                </ng-container>
                <span
                  ><input
                    class="enter-coupon-amount--input linear__user__flow p__bottom-32"
                    [ngClass]="{ 'uppercase-text': showSubTypeUpperCase }"
                    id="singleFamilyArmInputSubType"
                    formControlName="singleFamilyArmSubTypeInputControl"
                    type="text"
                    placeholder="Enter subtype"
                    maxlength="3"
                    invdAvoidSpecialChar
                    [(ngModel)]="sfARMsubTypeInput"
                    autocomplete="off"
                  />
                </span>
              </div>
            </div>

            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-deal-amount">
                <label>Deal Amount</label>
                <div class="input-group-container">
                  <ng-container
                    *ngIf="
                      requestSingleFamilyArmMegaForm.controls.singleFamilyArmMegaAmountInputControl
                        .value !== '' &&
                      isDealAmtLessThanOneThousand &&
                      !requestSingleFamilyArmMegaForm.controls.singleFamilyArmMegaAmountInputControl
                        .pristine
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error enter-mega-trade-error-tooltip"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The deal amount for a mega must be more than $1,000. Please try again."
                    ></i>
                  </ng-container>
                  <span class="currency-addon">$</span>
                  <input
                    class="enter-coupon-amount--input linear__user__flow p__bottom-32"
                    id="singleFamilyArmInputMegaAmount"
                    [textMask]="{ mask: numberMask }"
                    formControlName="singleFamilyArmMegaAmountInputControl"
                    type="text"
                    invdWholeNumberOnly
                    onCopy="return false;"
                    onCut="return false;"
                    onpaste="return false;"
                    ondrag="return false;"
                    onDrop="return false;"
                    placeholder="Enter deal amount"
                    [(ngModel)]="sfArmDealAmount"
                    (blur)="
                      validateDealAmount(
                        requestSingleFamilyArmMegaForm.controls
                          .singleFamilyArmMegaAmountInputControl
                      )
                    "
                    (focus)="isDealAmtLessThanOneThousand = false"
                    autocomplete="off"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-settelment-date">
                <label>Settlement Date</label>
                <div class="input-group-container p__bottom-32">
                  <i
                    class="fa fa-calendar calendar-addon"
                    id="sfamCalenderBtn"
                    (click)="dp.openCalendar()"
                  ></i>

                  <span id="sfamCalenderCtr">
                    <input
                      class="input-calendar"
                      readonly
                      (dateChanged)="onDateChanged($event)"
                      (click)="dp.openCalendar()"
                      placeholder="mm/dd/yyyy"
                      angular-mydatepicker
                      [(ngModel)]="calendarModel"
                      formControlName="singleFamilyArmMegaSettlemntDateControl"
                      [options]="singleFamilyArmMegaSettlemntDateControlOptions"
                      #dp="angular-mydatepicker"
                    />
                  </span>

                  <div class="calender-busy-indicator" *ngIf="showCalendarBusyIndicator">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw spinner-pos" aria-hidden="true"></i>
                    <span class="loading-calender-text">loading calendar...</span>
                  </div>

                  <span
                    class="calender-tool-tip fa-stack fa-lg tooltip-error enter-mega-trade-error-tooltip"
                    aria-hidden="true"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    *ngIf="canIShowCalenderToolTip(dateSelected)"
                    title="The market closes early on the day you chose. Please be sure staff is available to complete this transaction."
                  >
                    <i class="fa fa-info fa-stack-1x"></i>
                    <i class="fa fa-circle-thin fa-stack-2x"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedMegas != null && isMultiFamilyFixSelected">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <form class="row mega-type-form" [formGroup]="requestMultiFamilyFixMegaForm">
            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 mf-fixed-rate--prefix">
                <label>Prefix</label>
                <div class="fm-cdx-select p__bottom-32">
                  <select
                    name="multiFamilyFixPrefixSelection"
                    formControlName="multiFamilyFixPrefixSelControl"
                    [ngModel]="multiFamilyFixSelectedPrefix"
                    (ngModelChange)="multiFamilyFixSetSelectedPrefix($event)"
                  >
                    <option disabled [ngValue]="null">Select a prefix</option>
                    <option
                      *ngFor="let prefix of selectedMegas?.prefixTypes; trackBy: trackByIdentity"
                      [ngValue]="prefix"
                    >
                      {{ prefix.prefixCode }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="mega-inline-block mf-fixed-rate--form">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>High Coupon</label>
                <div class="input-group-container p__bottom-32">
                  <ng-container
                    *ngIf="
                      requestMultiFamilyFixMegaForm.controls.megaHighCouponInputControl.hasError(
                        'CouponError_two'
                      ) ||
                      requestMultiFamilyFixMegaForm.controls.megaLowCouponInputControl.hasError(
                        'CouponError_two'
                      )
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The difference between the High Coupon and Low Coupon must be 1 or less. Please try again."
                    ></i>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      requestMultiFamilyFixMegaForm.controls.megaHighCouponInputControl.hasError(
                        'CouponError_one'
                      ) ||
                      requestMultiFamilyFixMegaForm.controls.megaLowCouponInputControl.hasError(
                        'CouponError_one'
                      )
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The value of the High Coupon must be greater than the Low Coupon. Please try again."
                    ></i>
                  </ng-container>
                  <input
                    class="enter-coupon-amount-__input linear__user__flow"
                    id="inputMegaMultiFamilyFixHighCoupon"
                    formControlName="megaHighCouponInputControl"
                    type="text"
                    invdUptoThreeDecimal
                    onCopy="return false;"
                    onCut="return false;"
                    onpaste="return false;"
                    ondrag="return false;"
                    onDrop="return false;"
                    placeholder="Enter high coupon"
                    [(ngModel)]="mfFixHighCouponAmount"
                    (ngModelChange)="highCouponValueChanged()"
                    autocomplete="off"
                    (keydown.enter)="
                      formatCouponDecimal(
                        $event,
                        requestMultiFamilyFixMegaForm.controls.megaHighCouponInputControl
                      )
                    "
                    (blur)="
                      formatCouponDecimal(
                        $event,
                        requestMultiFamilyFixMegaForm.controls.megaHighCouponInputControl
                      )
                    "
                  />
                </div>
              </div>

              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Low Coupon</label>
                <div class="input-group-container p__bottom-32">
                  <ng-container
                    *ngIf="
                      requestMultiFamilyFixMegaForm.controls.megaHighCouponInputControl.hasError(
                        'CouponError_two'
                      ) ||
                      requestMultiFamilyFixMegaForm.controls.megaLowCouponInputControl.hasError(
                        'CouponError_two'
                      )
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The difference between the High Coupon and Low Coupon must be 1 or less. Please try again."
                    ></i>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      requestMultiFamilyFixMegaForm.controls.megaHighCouponInputControl.hasError(
                        'CouponError_one'
                      ) ||
                      requestMultiFamilyFixMegaForm.controls.megaLowCouponInputControl.hasError(
                        'CouponError_one'
                      )
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The value of the High Coupon must be greater than the Low Coupon. Please try again."
                    ></i>
                  </ng-container>
                  <input
                    class="enter-coupon-amount-__input linear__user__flow"
                    id="inputMegaMultiFamilyFixLowCoupon"
                    formControlName="megaLowCouponInputControl"
                    type="text"
                    invdUptoThreeDecimal
                    onCopy="return false;"
                    onCut="return false;"
                    onpaste="return false;"
                    ondrag="return false;"
                    onDrop="return false;"
                    placeholder="Enter low coupon"
                    [(ngModel)]="mfFixLowCouponAmount"
                    (ngModelChange)="lowCouponValueChanged()"
                    autocomplete="off"
                    (keydown.enter)="
                      formatCouponDecimal(
                        $event,
                        requestMultiFamilyFixMegaForm.controls.megaLowCouponInputControl
                      )
                    "
                    (blur)="
                      formatCouponDecimal(
                        $event,
                        requestMultiFamilyFixMegaForm.controls.megaLowCouponInputControl
                      )
                    "
                  />
                </div>
              </div>
            </div>

            <div class="mega-inline-block mf-fixed-rate--form">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Deal Amount</label>
                <div class="input-group-container p__bottom-32">
                  <ng-container
                    *ngIf="
                      requestMultiFamilyFixMegaForm.controls.multiFamilyFixMegaAmountInputControl
                        .value !== '' &&
                      isDealAmtLessThanOneThousand &&
                      !requestMultiFamilyFixMegaForm.controls.multiFamilyFixMegaAmountInputControl
                        .pristine
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error enter-mega-trade-error-tooltip"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The deal amount for a mega must be more than $1,000. Please try again."
                    ></i>
                  </ng-container>
                  <span class="currency-addon">$</span>
                  <input
                    class="enter-coupon-amount-__input linear__user__flow"
                    id="multiFamilyFixInputMegaAmount"
                    [textMask]="{ mask: numberMask }"
                    onCopy="return false;"
                    onCut="return false;"
                    onpaste="return false;"
                    ondrag="return false;"
                    onDrop="return false;"
                    formControlName="multiFamilyFixMegaAmountInputControl"
                    type="text"
                    invdWholeNumberOnly
                    placeholder="Enter deal amount"
                    [(ngModel)]="mfFixDealAmount"
                    (blur)="
                      validateDealAmount(
                        requestMultiFamilyFixMegaForm.controls.multiFamilyFixMegaAmountInputControl
                      )
                    "
                    (focus)="isDealAmtLessThanOneThousand = false"
                    autocomplete="off"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Settlement Date</label>
                <div class="input-group-container p__bottom-32">
                  <i
                    class="fa fa-calendar calendar-addon"
                    id="mffmCalenderBtn"
                    (click)="dp.openCalendar()"
                  ></i>

                  <span id="mffmCalenderCtr">
                    <input
                      class="input-calendar"
                      readonly
                      (dateChanged)="onDateChanged($event)"
                      (click)="dp.openCalendar()"
                      placeholder="mm/dd/yyyy"
                      [(ngModel)]="calendarModel"
                      angular-mydatepicker
                      formControlName="multiFamilyFixMegaSettlemntDateControl"
                      [options]="multiFamilyFixMegaSettlemntDateControlOptions"
                      #dp="angular-mydatepicker"
                    />
                  </span>

                  <div class="calender-busy-indicator" *ngIf="showCalendarBusyIndicator">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw spinner-pos" aria-hidden="true"></i>
                    <span class="loading-calender-text">loading calendar...</span>
                  </div>

                  <span
                    class="calender-tool-tip fa-stack fa-lg tooltip-error enter-mega-trade-error-tooltip"
                    aria-hidden="true"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    *ngIf="canIShowCalenderToolTip(dateSelected)"
                    title="The market closes early on the day you chose. Please be sure staff is available to complete this transaction."
                  >
                    <i class="fa fa-info fa-stack-1x"></i>
                    <i class="fa fa-circle-thin fa-stack-2x"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedMegas != null && isMultiFamilyARMSelected">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <form class="row mega-type-form" [formGroup]="requestMultiFamilyArmMegaForm">
            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Prefix</label>
                <div class="fm-cdx-select p__bottom-32">
                  <select
                    name="multiFamilyArmPrefixSelection"
                    formControlName="multiFamilyArmPrefixSelControl"
                    [ngModel]="multiFamilyArmSelectedPrefix"
                    (ngModelChange)="multiFamilyArmSetSelectedPrefix($event)"
                  >
                    <option disabled [ngValue]="null">Select a prefix</option>
                    <option
                      *ngFor="let prefix of selectedMegas?.prefixTypes; trackBy: trackByIdentity"
                      [ngValue]="prefix"
                    >
                      {{ prefix.prefixCode }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <label>Subtype</label>
                <ng-container
                  *ngIf="
                    requestMultiFamilyArmMegaForm.controls.multiFamilyArmSubTypeInputControl.hasError(
                      'subTypeError'
                    )
                  "
                >
                </ng-container>
                <span>
                  <input
                    class="enter-coupon-amount--input linear__user__flow p__bottom-32"
                    [ngClass]="{ 'uppercase-text': showSubTypeUpperCase }"
                    id="multiFamilyArmInputSubType"
                    formControlName="multiFamilyArmSubTypeInputControl"
                    type="text"
                    placeholder="Enter subtype"
                    maxlength="3"
                    invdAvoidSpecialChar
                    [(ngModel)]="mfARMsubTypeInput"
                    autocomplete="off"
                  />
                </span>
              </div>
            </div>

            <div class="mega-inline-block">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-deal-amount">
                <label>Deal Amount</label>
                <div class="input-group-container">
                  <ng-container
                    *ngIf="
                      requestMultiFamilyArmMegaForm.controls.multiFamilyArmMegaAmountInputControl
                        .value !== '' &&
                      isDealAmtLessThanOneThousand &&
                      !requestMultiFamilyArmMegaForm.controls.multiFamilyArmMegaAmountInputControl
                        .pristine
                    "
                  >
                    <i
                      class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error enter-mega-trade-error-tooltip"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="The deal amount for a mega must be more than $1,000. Please try again."
                    ></i>
                  </ng-container>
                  <span class="currency-addon">$</span>
                  <input
                    class="enter-coupon-amount--input linear__user__flow p__bottom-32"
                    id="multiFamilyArmInputMegaAmount"
                    [textMask]="{ mask: numberMask }"
                    formControlName="multiFamilyArmMegaAmountInputControl"
                    type="text"
                    invdWholeNumberOnly
                    onCopy="return false;"
                    onCut="return false;"
                    onpaste="return false;"
                    ondrag="return false;"
                    onDrop="return false;"
                    placeholder="Enter deal amount"
                    [(ngModel)]="mfArmDealAmount"
                    (blur)="
                      validateDealAmount(
                        requestMultiFamilyArmMegaForm.controls.multiFamilyArmMegaAmountInputControl
                      )
                    "
                    (focus)="isDealAmtLessThanOneThousand = false"
                    autocomplete="off"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-settelment-date">
                <label>Settlement Date</label>
                <div class="input-group-container p__bottom-32">
                  <i
                    class="fa fa-calendar calendar-addon"
                    id="mfamCalenderBtn"
                    (click)="dp.openCalendar()"
                  ></i>

                  <span id="mfamCalenderCtr">
                    <input
                      class="input-calendar"
                      readonly
                      (click)="dp.openCalendar()"
                      placeholder="mm/dd/yyyy"
                      angular-mydatepicker
                      [(ngModel)]="calendarModel"
                      (dateChanged)="onDateChanged($event)"
                      formControlName="multiFamilyArmMegaSettlemntDateControl"
                      [options]="multiFamilyArmMegaSettlemntDateControlOptions"
                      #dp="angular-mydatepicker"
                    />
                  </span>

                  <div class="calender-busy-indicator" *ngIf="showCalendarBusyIndicator">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw spinner-pos" aria-hidden="true"></i>
                    <span class="loading-calender-text">loading calendar...</span>
                  </div>

                  <span
                    class="calender-tool-tip fa-stack fa-lg tooltip-error enter-mega-trade-error-tooltip"
                    aria-hidden="true"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    *ngIf="canIShowCalenderToolTip(dateSelected)"
                    title="The market closes early on the day you chose. Please be sure staff is available to complete this transaction."
                  >
                    <i class="fa fa-info fa-stack-1x"></i>
                    <i class="fa fa-circle-thin fa-stack-2x"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedMegas != null">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega-buttons-block">
          <ng-container *ngIf="isEditMegaFlow">
            <button (click)="cancelMega()" class="button fm-tertiary-button cancel-edit-button">
              Cancel Edit
            </button>
          </ng-container>
          <button
            (click)="reviewMega()"
            class="button fm-primary-button review-button"
            type="button"
            [disabled]="
              isReviewButtonClicked
                ? true
                : isSingleFamilyFixSelected
                  ? !requestSingleFamilyFixMegaForm.valid
                  : isSingleFamilyARMSelected
                    ? !requestSingleFamilyArmMegaForm.valid
                    : isMultiFamilyFixSelected
                      ? !requestMultiFamilyFixMegaForm.valid
                      : isMultiFamilyARMSelected
                        ? !requestMultiFamilyArmMegaForm.valid
                        : false
            "
          >
            {{ reviewButtonText }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="displayNavigateAwayPopup">
  <div class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig">
      <button
        type="button"
        class="close float-end"
        aria-label="Close"
        (click)="displayNavigateAwayPopup = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="panel-body mega-cancel-confirmation-model">
        <p>If you leave this page your work will not be saved.</p>
        <br />
        <h4>Do you wish to proceed?</h4>
        <br />
        <button class="button fm-tertiary-button" (click)="displayNavigateAwayPopup = false">
          CANCEL
        </button>
        <button class="button fm-primary-button" (click)="navigatePageTo(destinationUrl)">
          YES
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="displayNavigateAwayCancelPopup">
  <div class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig">
      <button
        type="button"
        class="close float-end"
        aria-label="Close"
        (click)="displayNavigateAwayCancelPopup = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="panel-body mega-cancel-confirmation-model">
        <p>
          You are attempting to cancel your pool edits. <br />
          By doing so, any changes you have made will be lost. <br />
          Your pool will revert to its original attributes.
        </p>
        <br />
        <h4>Do you wish to proceed?</h4>
        <button class="button fm-tertiary-button" (click)="displayNavigateAwayCancelPopup = false">
          NO
        </button>
        <button class="button fm-primary-button" (click)="navigatePageTo(destinationUrl)">
          YES
        </button>
      </div>
    </div>
  </div>
</ng-container>
